// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.encounter.workflow.PatientAddWorkflowScreenToWorkflowStepRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientAddWorkflowScreenToWorkflowStepRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	addAfterWorkflowScreenId!: number | null;

	@GandalfValidator({ notNull: { message: 'Screen is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	workflowScreenTemplateId!: number;

	@GandalfValidator({ notNull: { message: 'Step is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	workflowStepId!: number;

}
